import React, { useState } from 'react';
import { Shuffle, Box, Grid, Gift, Zap, ChevronRight } from 'lucide-react';
import LightMiniKeysCluster from '../components/LightMiniKeysCluster';
import LightMixCluster from '../components/LightMixCluster';
import LightBoxCluster from '../components/LightBoxCluster';
import LightCaseCluster from '../components/LightCaseCluster';
import LightLotoCluster from '../components/LightLotoCluster';

const clusters = [
    {
        id: 'light-keys-mini',
        name: 'Light Keys Mini',
        subtitle: 'Живая очередь',
        icon: Zap,
        gradient: 'from-emerald-400 to-teal-500',
        borderColor: 'border-emerald-200 hover:border-emerald-400',
        topBar: 'from-emerald-400 to-teal-500',
        badgeBg: 'bg-emerald-100 text-emerald-700',
        dotColor: 'bg-emerald-500',
        decoBg: 'bg-emerald-100',
        isNew: true,
        description: 'Присоединяйтесь к живой очереди и получайте выплаты от новых участников. Минимальный вход — максимальная скорость.',
        stats: [
            { label: 'Вход', value: '$20' },
            { label: 'Выход', value: '$35' },
            { label: 'Позиций до закрытия', value: '4' },
            { label: 'Реферальные уровни', value: '3 уровня' },
        ],
        badge: 'Активно',
        extra: 'Старт 22 февраля',
    },
    {
        id: 'light-mix',
        name: 'Light Mix',
        subtitle: 'Розыгрыши',
        icon: Shuffle,
        gradient: 'from-pink-400 to-purple-500',
        borderColor: 'border-pink-200 hover:border-pink-400',
        topBar: 'from-pink-400 to-purple-500',
        badgeBg: 'bg-pink-100 text-pink-700',
        dotColor: 'bg-pink-400',
        decoBg: 'bg-pink-100',
        description: 'Розыгрыши по расписанию с уникальными наградами. Покупайте места и получайте денежные призы или билеты на следующий розыгрыш. А также своим участием помогайте движению в Light Box и Light Keys.',
        stats: [
            { label: 'Стоимость', value: '4 USDT' },
            { label: 'Награды', value: 'USDT + Keys + Mix' },
        ],
        badge: 'Активно',
    },
    {
        id: 'light-box',
        name: 'Light Box',
        subtitle: 'Матричная структура',
        icon: Box,
        gradient: 'from-sky-400 to-blue-500',
        borderColor: 'border-sky-200 hover:border-sky-400',
        topBar: 'from-sky-400 to-blue-500',
        badgeBg: 'bg-sky-100 text-sky-700',
        dotColor: 'bg-sky-400',
        decoBg: 'bg-sky-100',
        description: 'Матричная структура с автоматическим заполнением. Присоединяйтесь и получайте доход от заполнения вашей матрицы партнерами.',
        stats: [
            { label: 'Тарифы', value: '5 уровней' },
            { label: 'Доход до', value: '$25,000' },
        ],
        badge: 'Активно',
    },
    {
        id: 'light-keys',
        name: 'Light Keys',
        subtitle: 'Очередь выплат',
        icon: Grid,
        gradient: 'from-violet-400 to-purple-600',
        borderColor: 'border-violet-200 hover:border-violet-400',
        topBar: 'from-violet-400 to-purple-600',
        badgeBg: 'bg-violet-100 text-violet-700',
        dotColor: 'bg-violet-400',
        decoBg: 'bg-violet-100',
        description: 'Очередь выплат с гарантированным доходом. Приобретайте места в очереди и получайте выплаты от новых участников.',
        stats: [
            { label: 'Тарифы', value: '4 уровня' },
            { label: 'Доход до', value: '$50,000' },
        ],
        badge: 'Активно',
    },
    {
        id: 'light-loto',
        name: 'Light Loto',
        subtitle: 'Ежедневный джекпот',
        icon: Gift,
        gradient: 'from-amber-400 to-orange-500',
        borderColor: 'border-amber-200 hover:border-amber-400',
        topBar: 'from-amber-400 to-orange-500',
        badgeBg: 'bg-amber-100 text-amber-700',
        dotColor: 'bg-amber-400',
        decoBg: 'bg-amber-100',
        description: 'Каждый день новый шанс выиграть джекпот или другие ценные призы. Неограниченное количество попыток в день.',
        stats: [
            { label: 'Джекпот', value: 'От 100 USDT' },
            { label: 'Попыток в день', value: 'Неограниченно' },
        ],
        badge: 'Активно',
    },
];

const ClustersPage = () => {
    const [selectedCluster, setSelectedCluster] = useState(null);

    if (selectedCluster === 'light-keys-mini') {
        return <LightMiniKeysCluster onBack={() => setSelectedCluster(null)} />;
    }
    if (selectedCluster === 'light-mix') {
        return <LightMixCluster onBack={() => setSelectedCluster(null)} />;
    }
    if (selectedCluster === 'light-box') {
        return <LightBoxCluster onBack={() => setSelectedCluster(null)} />;
    }
    if (selectedCluster === 'light-keys') {
        return <LightCaseCluster onBack={() => setSelectedCluster(null)} />;
    }
    if (selectedCluster === 'light-loto') {
        return <LightLotoCluster onBack={() => setSelectedCluster(null)} />;
    }

    return (
        <div className="p-3 sm:p-4 md:p-6">
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-blue-500 mb-3 sm:mb-4 md:mb-6">
                Кластеры
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                {clusters.map((cluster) => {
                    const Icon = cluster.icon;
                    return (
                        <div
                            key={cluster.id}
                            onClick={() => setSelectedCluster(cluster.id)}
                            className={`
                                group relative bg-white rounded-2xl border shadow-sm overflow-hidden
                                transition-all duration-300 cursor-pointer
                                ${cluster.borderColor}
                                hover:shadow-lg hover:-translate-y-1
                            `}
                        >
                            {/* Верхняя градиентная полоска */}
                            <div className={`h-1.5 bg-gradient-to-r ${cluster.topBar}`} />

                            {/* Декоративный круг */}
                            <div className={`absolute top-3 right-3 w-16 h-16 rounded-full ${cluster.decoBg} opacity-40 pointer-events-none`} />

                            <div className="p-4 sm:p-5">
                                {/* Заголовок */}
                                <div className="flex items-center justify-between mb-3">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${cluster.gradient} flex items-center justify-center shadow-md flex-shrink-0`}>
                                            <Icon size={20} className="text-white" />
                                        </div>
                                        <div>
                                            <div className="flex items-center gap-2">
                                                <h3 className="text-base sm:text-lg font-bold text-gray-800">{cluster.name}</h3>
                                                {cluster.isNew && (
                                                    <span className="text-[9px] font-semibold px-1.5 py-0.5 bg-emerald-500 text-white rounded-full leading-none">
                                                        NEW
                                                    </span>
                                                )}
                                            </div>
                                            <p className="text-[10px] sm:text-xs text-gray-500">{cluster.subtitle}</p>
                                        </div>
                                    </div>
                                    <ChevronRight
                                        size={20}
                                        className="text-gray-300 group-hover:text-gray-500 transition-colors flex-shrink-0"
                                    />
                                </div>

                                {/* Описание */}
                                <p className="text-xs text-gray-500 mb-3 leading-relaxed">
                                    {cluster.description}
                                </p>

                                {/* Статистика */}
                                <div className="border-t border-gray-100 pt-3 space-y-1.5">
                                    {cluster.stats.map((stat, i) => (
                                        <div key={i} className="flex items-center justify-between">
                                            <span className="text-xs text-gray-500">{stat.label}:</span>
                                            <span className={`text-xs font-semibold bg-gradient-to-r ${cluster.gradient} bg-clip-text text-transparent`}>
                                                {stat.value}
                                            </span>
                                        </div>
                                    ))}
                                </div>

                                {/* Нижняя панель */}
                                <div className="mt-3 flex items-center justify-between">
                                    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-medium ${cluster.badgeBg}`}>
                                        <span className={`w-1.5 h-1.5 rounded-full ${cluster.dotColor} animate-pulse`} />
                                        {cluster.badge}
                                    </span>
                                    {cluster.extra
                                        ? <span className="text-[10px] text-gray-400">{cluster.extra}</span>
                                        : (
                                            <span className={`text-xs font-medium bg-gradient-to-r ${cluster.gradient} bg-clip-text text-transparent group-hover:underline`}>
                                                Подробнее →
                                            </span>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ClustersPage;
